import { logEvent as firebaseLogEvent, getAnalytics } from 'firebase/analytics';
import React, { createContext, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useFirebaseApp } from './FirebaseAppProvider';

const propTypes = {
  children: PropTypes.node,
};
const defaultProps = {
  children: undefined,
};

const FirebaseAnalyticsContext = createContext(null);

export function FirebaseAnalyticsProvider({ children }) {
  const app = useFirebaseApp();
  const sdk = getAnalytics(app);

  // Memoized so the context value is stable across renders.
  const logEvent = useCallback(
    (event, eventParams) => {
      firebaseLogEvent(sdk, event, eventParams);
    },
    [sdk],
  );

  return (
    <FirebaseAnalyticsContext.Provider value={logEvent}>
      {children}
    </FirebaseAnalyticsContext.Provider>
  );
}

FirebaseAnalyticsProvider.propTypes = propTypes;
FirebaseAnalyticsProvider.defaultProps = defaultProps;

export function useFirebaseAnalytics() {
  const value = useContext(FirebaseAnalyticsContext);

  if (value === null) {
    throw new Error('useAnalytics must be used within a AnalyticsProvider');
  }

  return value;
}